import React from 'react';
import { GoogleLogin } from '@react-oauth/google';

/**
 * Google Sign-In Button Component
 *
 * This component handles Google OAuth sign-in.
 * It receives a Google ID token and passes it to the parent component.
 *
 * Usage:
 *   <GoogleSignInButton onSuccess={handleGoogleSuccess} onError={handleGoogleError} />
 */
const GoogleSignInButton = ({ onSuccess, onError, text = "signin_with", theme = "filled_blue" }) => {
  const handleSuccess = (credentialResponse) => {
    // credentialResponse contains the JWT ID token
    // Format: { credential: "eyJhbGc..." }
    // Pass the full object so parent can access credentialResponse.credential
    if (onSuccess) {
      onSuccess(credentialResponse);
    }
  };

  const handleError = () => {
    if (onError) {
      onError('Google Sign-In failed');
    }
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={handleError}
      text={text}
      theme={theme}
      shape="rectangular"
      size="large"
      logo_alignment="left"
    />
  );
};

export default GoogleSignInButton;
